// Apolo IDE — SegmentedControl (ui, sprint composer-anchor E4).
//
// Controle segmentado estilo iOS pra modos de 2-4 opções (ex: Worktree|Direto).
// Acessível sem dep nova: role=radiogroup + arrows + foco visível. Substitui o
// pill-dropdown de modo (mais natural/rápido pra escolha binária).

import { useRef } from 'react';

/**
 * @param {{ value: string, options: Array<{value:string,label:string,title?:string}>,
 *   onChange: (v:string)=>void, ariaLabel: string, className?: string }} props
 */
export default function SegmentedControl({ value, options, onChange, ariaLabel, className = '' }) {
  const ref = useRef(null);

  function onKeyDown(e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const idx = options.findIndex((o) => o.value === value);
    const next = e.key === 'ArrowRight' ? (idx + 1) % options.length : (idx - 1 + options.length) % options.length;
    onChange(options[next].value);
    requestAnimationFrame(() => {
      ref.current?.querySelector(`[data-val="${options[next].value}"]`)?.focus();
    });
  }

  return (
    <div
      ref={ref}
      role="radiogroup"
      aria-label={ariaLabel}
      onKeyDown={onKeyDown}
      className={
        'inline-flex items-center gap-0.5 rounded-full border border-apolo-borderSubtle bg-apolo-surface2 p-0.5 ' +
        className
      }
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-val={o.value}
            tabIndex={active ? 0 : -1}
            title={o.title}
            onClick={() => onChange(o.value)}
            className={
              'rounded-full px-2.5 py-1 text-[11px] leading-none transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accentRing ' +
              (active
                ? 'border border-apolo-borderSubtle bg-apolo-surface1 text-apolo-textPrimary'
                : 'border border-transparent text-apolo-textTertiary hover:text-apolo-textSecondary')
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
